import { useEffect } from "react";
import { SOURCE_EDGE, sourceMetadataFromClient } from "../lib/sourceMetadata";

/**
 * PLEX-5920: register the evidence tool results' source_metadata ({url: {title, description}}) with
 * the source cards, so a cited evidence URL shows its edge's title and description rather than the
 * page's own metadata.
 *
 * Those results come from the search analyst, a sub-agent, so they are in client.subAgentTurns
 * while it runs and in a turn's agentMessagesCache after a reload, not in a rendered block of the
 * main turns. Polled at 1Hz, like useEntityDiscovery: client.turns is mutated in place and the
 * sub-agent map is nested, so an effect on them would not re-run; registration skips what is
 * already registered, so a tick with nothing new does nothing.
 */
const useSourceMetadata = (client, sourceReferencesStore) => {
  useEffect(() => {
    if (!client || !sourceReferencesStore?.registerDescriptions) return undefined;
    const tick = () => {
      try {
        sourceReferencesStore.registerDescriptions(sourceMetadataFromClient(client), SOURCE_EDGE);
      } catch (_) { /* never break the chat surface */ }
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [client, sourceReferencesStore]);
};

export default useSourceMetadata;
